/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AddBoxOutlined, Checkroom, ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG_PRIMERA_ARR
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import Dialogo_Producto_Pasarela from "../Dialogos/Dialogo_Producto_Pasarela";
import Dialogo_Fotos from "../Dialogos/Dialogo_Fotos";
import Dialogo_Foto_Producto from "../Dialogos/Dialogo_Foto_Producto";


const Seccion_Fotos = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'fotos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Fotos,
        titulo: 'Detalles del Match',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPasarela, abrir: abrirPasarela} = useDialogo({
        Componente: Dialogo_Foto_Producto,
        titulo: 'Prendas de foto',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'prendas':
                abrirPasarela(data)
                break
        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoPasarela/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Fotos de Match'}
                        descripcion={`${numeroFilas} fotos en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Fotos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Portada',
        direccion: 'left',
        propiedad: 'imgs',
        size: 60,
        tipo: CASILLA_IMG_PRIMERA_ARR

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['coleccion'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: '# Prendas',
        direccion: 'left',
        propiedad: 'productos',
        tipo: CASILLA_CONTAR_ARR
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Prendas',
        id: 'prendas',
        icono: Checkroom
    }
]


